import React, { useState, useRef, useEffect } from 'react';
import './Chatbot.css'; 

const Chatbot = () => {
  const [messages, setMessages] = useState([
    { text: "नमस्ते! मैं Unnat Kheti का चैटबॉट हूँ। कृषि से संबंधित कोई सवाल पूछें, जैसे 'फसल रोग कैसे पहचानें?' या 'सरकारी योजनाएँ क्या हैं?'", sender: 'bot' }
  ]);
  const [input, setInput] = useState('');
  const [isOpen, setIsOpen] = useState(false);
  const messagesEndRef = useRef(null);

  const scrollToBottom = () => {
    messagesEndRef.current?.scrollIntoView({ behavior: 'smooth' });
  };

  useEffect(() => {
    scrollToBottom();
  }, [messages]);

  // Simple rule-based responses (expand this object with more rules based on site content)
  const getBotResponse = (userMessage) => {
    const lowerMsg = userMessage.toLowerCase();
    
    // Crop diseases
    if (lowerMsg.includes('रोग') || lowerMsg.includes('disease')) {
      return 'फसल रोगों के लिए: टमाटर में पीला पन - फंगस संक्रमण से होता है। जैविक उपाय: नीम तेल स्प्रे। अधिक जानकारी के लिए हमारी सेवाएँ देखें: /services/crop-diseases';
    }
    // Government schemes
    if (lowerMsg.includes('योजना') || lowerMsg.includes('scheme') || lowerMsg.includes('yojna')) {
      return 'सरकारी योजनाएँ: प्रधानमंत्री किसान सम्मान निधि (₹6000/वर्ष), किसान क्रेडिट कार्ड (कम ब्याज ऋण)। आवेदन के लिए government-schemes पर जाएँ।';
    }
    // Soil testing
    if (lowerMsg.includes('मिट्टी') || lowerMsg.includes('soil')) {
      return 'मिट्टी जाँच अभियान: मुफ्त परीक्षण उपलब्ध। संपर्क करें: unnatkheti@gmail.com या soil-testing पर रजिस्टर करें।';
    }
    // Products
    if (lowerMsg.includes('उत्पाद') || lowerMsg.includes('product')) {
      return 'हमारे उत्पाद: जैविक बीज , नीम कीटनाशक। ऑर्डर करें: products';
    }

    //prices
    if (lowerMsg.includes('कीटनाशक') || lowerMsg.includes('pesticides')) {
      return ' नीम आधारित कीटनाशक , फफूंदनाशक स्प्रे , खरपतवार नाशक , कीटनाशक पाउडर अधिक जानकारी के लिए करें: prodcts';
    }

    if (lowerMsg.includes('बीज') || lowerMsg.includes('seeds') || lowerMsg.includes('beej')) {
      return ' गेहूँ का बीज, धान का हाइब्रिड बीज, मक्का संकर बीज, सरसों उन्नत बीज अधिक जानकारी के लिए करें: prodcts';
    }
    
    if (lowerMsg.includes('उर्वरक') || lowerMsg.includes('fertilizers') || lowerMsg.includes('khaad')) {
      return ' जैविक खाद 25kg, यूरिया खाद 50kg, DAP खाद 50kg, पोटाश उर्वरक 50kg अधिक जानकारी के लिए करें: prodcts';
    }

     if (lowerMsg.includes('कृषि यंत्र') || lowerMsg.includes('farm machines') || lowerMsg.includes('machine')) {
      return ' थ्रेशर मशीन, सीड ड्रिल मशीन, हार्वेस्टर मशीन, अधिक जानकारी के लिए करें: prodcts';
    }    

     if (lowerMsg.includes('सिंचाई उपकरण') || lowerMsg.includes('drip system') || lowerMsg.includes('water irrigation system')) {
      return ' ड्रिप सिंचाई किट - ₹3500 , स्प्रिंकलर सिस्टम - ₹4200, सोलर वॉटर पंप - ₹25000, पाइप सिंचाई सेट - ₹2800, अधिक जानकारी के लिए करें: prodcts';
    }   
    
    if (lowerMsg.includes('जैविक उत्पाद') || lowerMsg.includes('organic fertilizer') || lowerMsg.includes('jaivik utpad')) {
      return ' जैविक कीटनाशक स्प्रे - ₹650 , वर्मीकम्पोस्ट 10kg - ₹350, जैविक फल स्प्रे - ₹750, जैविक ग्रोथ प्रमोटर - ₹550, अधिक जानकारी के लिए करें: prodcts';
    }   

    if (lowerMsg.includes('PM Kisan Samman Nidhi ki agli kist kab aayegi?') || lowerMsg.includes('organic fertilizer')) {
      return "किसान भाई, पीएम किसान सम्मान निधि की अगली किस्त सरकार द्वारा निर्धारित समय पर जारी की जाएगी। आमतौर पर यह साल में तीन बार—अप्रैल, अगस्त और दिसंबर—के महीनों में आती है। अगर आपकी पिछली किस्त नहीं आई है, तो हो सकता है कि आपकी e-KYC या आधार सीडिंग पूरी न हो। आप तुरंत pmkisan.gov.in पर जाकर अपना स्टेटस चेक करें या अपने नजदीकी कृषि विभाग से संपर्क करें। हमारी वेबसाइट के 'ब्लॉग' सेक्शन में भी ताज़ा अपडेट देखे जा सकते हैं।";
    }   

    if (lowerMsg.includes('Kisan Credit Card (KCC) kaise banwaye aur byaj kitna hai?')) {
      return  "KCC बनवाने के लिए आपको अपनी जमीन के कागजात (खतौनी), आधार कार्ड और बैंक पासबुक के साथ अपने नजदीकी बैंक शाखा में आवेदन करना होगा। KCC पर आमतौर पर 7% ब्याज लगता है, लेकिन अगर आप एक साल के अंदर पैसा वापस जमा कर देते हैं, तो सरकार आपको 3% की सब्सिडी देती है। यानी आपको केवल 4% ब्याज ही देना पड़ता है। यह खेती के खर्चों जैसे बीज और खाद के लिए सबसे सस्ता लोन है।";
    }   

    if (lowerMsg.includes('Tractor ya Krishi Yantra par Subsidy kaise milegi?')) {
      return  "ट्रैक्टर, रोटावेटर या अन्य कृषि यंत्रों पर सब्सिडी पाने के लिए आपको अपने राज्य के कृषि विभाग के पोर्टल (जैसे DBT Agriculture) पर ऑनलाइन पंजीकरण करना होता है। सरकार यंत्र की कीमत पर 40% से लेकर 80% तक सब्सिडी देती है (यह आपकी श्रेणी और राज्य पर निर्भर करता है)। आवेदन करने के बाद लॉटरी या 'पहले आओ पहले पाओ' के आधार पर चयन होता है। अधिक जानकारी के लिए हमारे 'योजना' पेज को देखें।";
    }   

    if (lowerMsg.includes('Gehu ka sabse accha beej kaun sa hai aur rate kya hai?')) {
      return  "हमारी वेबसाइट UnnatKheti पर उपलब्ध 'उन्नत किस्म का गेहूँ बीज' रबी सीजन के लिए सबसे बेहतरीन है। यह रोग प्रतिरोधक है और इसकी बालियाँ लंबी होती हैं, जिससे पैदावार ज्यादा मिलती है। 1 एकड़ खेत में बुवाई के लिए आपको लगभग 40 किलो बीज की आवश्यकता होगी। इसका 40 किलो का बैग हमारी वेबसाइट पर ₹1200 में उपलब्ध है। यह कम पानी में भी अच्छा उत्पादन देता है। इसे अभी आर्डर करने के लिए नीचे दिए गए लिंक पर क्लिक करें।";
    }
    
    if (lowerMsg.includes('Dhan aur Makka ke Hybrid beej ki jankari dein.')){
      return "हम आपके लिए लाए हैं उच्च गुणवत्ता वाला 'धान का हाइब्रिड बीज' (₹1500/बैग) और 'मक्का संकर बीज' (₹1800/बैग)। हमारे धान के बीज कम अवधि में तैयार होते हैं और ब्लास्ट रोग के प्रति सहनशील हैं। मक्का का बीज 90-100 दिनों में पक जाता है और इसमें दाने पूरे भरते हैं। अगर आप अभी ऑर्डर करते हैं, तो हम 5-7 दिनों के भीतर बीज सीधे आपके घर पहुँचा देंगे। अच्छी फसल के लिए प्रमाणित बीज ही बोएं।";
    }

    if (lowerMsg.includes('Jaivik Khad aur Urea mein kya antar hai? Rate kya hai?')){
      return "यूरिया पौधे को तुरंत नाइट्रोजन देता है (कीमत: ₹1200/50kg), लेकिन इसका ज्यादा इस्तेमाल मिट्टी को सख्त बना देता है। इसके विपरीत, हमारी 'जैविक खाद' (कीमत: ₹899/25kg) मिट्टी की जल धारण क्षमता बढ़ाती है और जमीन को भुरभुरा बनाती है। हम सलाह देते हैं कि आप रसायनों का प्रयोग धीरे-धीरे कम करें और जैविक खाद अपनाएं। इससे आपकी फसल की क्वालिटी अच्छी होगी और बाजार में दाम भी अच्छा मिलेगा। जैविक खाद आर्डर करने के लिए यहाँ क्लिक करें।";
    }

    if (lowerMsg.includes('Kechua Khad ke kya fayde hain?')){
      return "वर्मीकम्पोस्ट या केंचुआ खाद फसलों के लिए 'ब्लैक गोल्ड' मानी जाती है। इसमें नाइट्रोजन, फास्फोरस और पोटाश के साथ-साथ कई सूक्ष्म पोषक तत्व भी होते हैं जो सामान्य गोबर की खाद में नहीं मिलते। यह पौधों की जड़ों का विकास तेजी से करता है। अगर आप सब्जी या फलों की खेती करते हैं, तो केंचुआ खाद का प्रयोग जरूर करें। UnnatKheti पर शुद्ध वर्मीकम्पोस्ट उपलब्ध है, जिसे आप घर बैठे मंगवा सकते हैं।";
    }

    if (lowerMsg.includes('Mini Tractor ka price kya hai aur kya khasiyat hai?')){
      return "UnnatKheti का 'मिनी ट्रैक्टर' छोटे और मध्यम किसानों के लिए वरदान है। इसकी कीमत मात्र ₹1,85,000 है। यह 15-20 HP की ताकत के साथ आता है जो जुताई, बुवाई और ट्रॉली खींचने के काम आसानी से कर सकता है। यह बड़े ट्रैक्टर के मुकाबले बहुत कम डीजल खाता है और छोटे खेतों या बगीचों में आसानी से घूम सकता है। अगर आप इसे खरीदना चाहते हैं या EMI की जानकारी चाहते हैं, तो हमारे सपोर्ट नंबर पर कॉल करें।";
    }

    if (lowerMsg.includes(' Drip Irrigation kit ka kharch kitna hai?')){
      return "पानी की कमी वाले क्षेत्रों के लिए ड्रिप सिंचाई सबसे अच्छी तकनीक है। हमारी 'ड्रिप सिंचाई किट' छोटे किसानों के लिए विशेष रूप से तैयार की गई है, जिसकी कीमत केवल ₹3,500 है। इससे पानी सीधे पौधों की जड़ों में जाता है, जिससे 60-70% पानी की बचत होती है और खरपतवार भी कम उगते हैं। इसे लगाना बहुत आसान है। आप इसे सब्जियों और गन्ने की खेती में इस्तेमाल कर सकते हैं। अभी ऑर्डर करें।";
    }
    
    if (lowerMsg.includes('खेती की समस्या और रोग')){
      return "पत्ते मुड़ने की समस्या (Leaf Curl Virus) अक्सर 'सफेद मक्खी' (Whitefly) के कारण फैलती है। जैसे ही आपको लक्षण दिखें, प्रभावित पौधों को उखाड़कर जमीन में गाड़ दें ताकि यह दूसरे पौधों में न फैले। रासायनिक नियंत्रण के लिए आप 'इमिडाक्लोप्रिड' (Imidacloprid) का छिड़काव कर सकते हैं। जैविक उपाय के लिए हमारा 'नीम आधारित कीटनाशक' (₹450) बहुत असरदार है। इसे हर 10-15 दिन में छिड़कने से कीड़े पास नहीं आते।";
    }

    if (lowerMsg.includes('Mitti Jaanch kaise karwayein aur kyu zaruri hai?')){
      return "बिना मिट्टी जाँच के खाद डालना अंधेरे में तीर चलाने जैसा है। UnnatKheti के 'मिट्टी जाँच अभियान' के तहत आप अपनी मिट्टी का परीक्षण करवा सकते हैं। इसके लिए खेत की 6 इंच गहरी मिट्टी का सैंपल लेकर हमारे लैब में भेजें। रिपोर्ट में आपको पता चलेगा कि खेत में किस पोषक तत्व की कमी है। इससे आप केवल ज़रूरी खाद डालेंगे, जिससे आपकी लागत कम होगी और पैदावार बढ़ेगी। जांच के लिए आज ही रजिस्ट्रेशन करें।";
    }

    if (lowerMsg.includes('Order kaise karein aur delivery kab milegi?')){
      return "ऑर्डर करना बहुत आसान है। आप हमारी वेबसाइट UnnatKheti.org पर जाकर अपने मनपसंद उत्पाद (बीज, खाद, मशीन) को 'Add to Cart' करें और अपना पता भरकर ऑर्डर कन्फर्म करें। हम आम तौर पर 5 से 7 दिनों के भीतर पूरे भारत में डिलीवरी करते हैं। आप ऑनलाइन पेमेंट कर सकते हैं या चुनिंदा जगहों पर 'Cash on Delivery' (COD) की सुविधा भी उपलब्ध है। किसी भी सहायता के लिए हमें कॉल करें।";
    }

    if (lowerMsg.includes('Kya aap kheti ki training ya salah dete hain?')){
      return "जी हाँ, UnnatKheti का उद्देश्य केवल सामान बेचना नहीं, बल्कि किसान को समृद्ध बनाना है। हम समय-समय पर जैविक खेती, आधुनिक तकनीक और मशरूम की खेती पर ट्रेनिंग प्रोग्राम चलाते हैं। हमारे पास कृषि विशेषज्ञों (Agri-Experts) की टीम भी है। अगर आपकी फसल में कोई रोग है या आप नई खेती शुरू करना चाहते हैं, तो आप हमारे व्हाट्सएप नंबर पर अपनी फसल की फोटो भेजकर मुफ्त सलाह ले सकते हैं।";
    }

    // PM Kisan Installment & General Info
    if (lowerMsg.includes('pm kisan') || lowerMsg.includes('samman nidhi') || lowerMsg.includes('kist')) {
        return "किसान भाई, पीएम किसान सम्मान निधि की अगली किस्त सरकार द्वारा निर्धारित समय (आमतौर पर अप्रैल, अगस्त, या दिसंबर) पर जारी की जाएगी। अगर आपकी पिछली किस्त नहीं आई है, तो pmkisan.gov.in पर अपना स्टेटस और e-KYC चेक करें।";
    }

    // PM Kisan Status & Ststopped Payment
    if (lowerMsg.includes('status') || lowerMsg.includes('paisa ruk') || lowerMsg.includes('paisa nahi aaya')) {
        return "अपना स्टेटस चेक करने के लिए pmkisan.gov.in पर 'Farmers Corner' में जाएं। अगर पैसा रुका है, तो बैंक में आधार सीडिंग (DBT) और e-KYC की जाँच करवाएं या कृषि विभाग से संपर्क करें।";
    }

    // e-KYC
    if (lowerMsg.includes('kyc') || lowerMsg.includes('e-kyc')) {
        return "e-KYC अनिवार्य है। आप इसे pmkisan.gov.in पर OTP के जरिए खुद कर सकते हैं या नजदीकी CSC सेंटर पर जाकर बायोमेट्रिक तरीके से करवा सकते हैं।";
    }

    // New Registration
    if (lowerMsg.includes('registration') || lowerMsg.includes('panjikaran') || lowerMsg.includes('naya kisan')) {
        return "नए रजिस्ट्रेशन के लिए आधार कार्ड, बैंक पासबुक, खतौनी (जमीन के कागज) और मोबाइल नंबर की जरूरत है। आप PM Kisan पोर्टल या CSC केंद्र से आवेदन कर सकते हैं।";
    }

    // Kisan Credit Card (KCC)
    if (lowerMsg.includes('kcc') || lowerMsg.includes('credit card') || lowerMsg.includes('loan')) {
        return "KCC बनवाने के लिए बैंक में जमीन के कागज, आधार और पासबुक जमा करें। इस पर 7% ब्याज लगता है, और समय पर चुकाने पर केवल 4% लगता है। 1 एकड़ पर ₹40,000-₹60,000 तक लोन मिल सकता है।";
    }

    // General Subsidy
    if (lowerMsg.includes('subsidy') || lowerMsg.includes('chhoot') || lowerMsg.includes('anudan')) {
        return "कृषि यंत्रों, सोलर पंप और ड्रिप सिंचाई पर सरकार 40% से 90% तक सब्सिडी देती है। इसके लिए आपको अपने राज्य के कृषि विभाग के पोर्टल (जैसे DBT Agriculture) पर ऑनलाइन आवेदन करना होगा।";
    }

    // Fasal Bima (Insurance)
    if (lowerMsg.includes('bima') || lowerMsg.includes('insurance') || lowerMsg.includes('claim')) {
        return "फसल खराब होने के 72 घंटे के भीतर बीमा कंपनी या कृषि अधिकारी को सूचित करें। आप 'Crop Insurance App' के जरिए भी क्लेम कर सकते हैं। KCC वाले किसानों का बीमा बैंक द्वारा स्वतः होता है।";
    }

    // Solar Pump (Kusum Yojana)
    if (lowerMsg.includes('solar') || lowerMsg.includes('pump') || lowerMsg.includes('kusum')) {
        return "पीएम कुसुम योजना के तहत सोलर पंप पर 90% तक सब्सिडी मिलती है। आवेदन केवल आधिकारिक सरकारी वेबसाइट (.gov.in) से करें, फर्जी वेबसाइटों से सावधान रहें।";
    }


    // --- CATEGORY 2: SEEDS & BUYING (Beej Kharidari) ---

    // Wheat (Gehu)
    if (lowerMsg.includes('gehu') || lowerMsg.includes('wheat') || lowerMsg.includes('sharbati')) {
        return "रबी सीजन के लिए 'उन्नत किस्म का गेहूँ बीज' (कीमत ₹1200/40kg) उपलब्ध है। यह रतुआ रोग प्रतिरोधी है और 1 एकड़ में 40kg लगता है। आर्डर करने के लिए वेबसाइट के Product सेक्शन में जाएं।";
    }

    // Paddy (Dhan)
    if (lowerMsg.includes('dhan') || lowerMsg.includes('paddy') || lowerMsg.includes('chawal')) {
        return "हमारा 'हाइब्रिड धान बीज' (₹1500/बैग) कम पानी में पकता है और तना मजबूत होता है। बासमती (Pusa 1121/1509) किस्में भी उपलब्ध हैं। 1 एकड़ में 6 किलो हाइब्रिड बीज लगता है।";
    }

    // Maize (Makka)
    if (lowerMsg.includes('makka') || lowerMsg.includes('maize') || lowerMsg.includes('bhutta')) {
        return "हाई यील्डिंग हाइब्रिड मक्का बीज ₹1800/बैग में उपलब्ध है। यह 90-100 दिन में तैयार होता है और दाने पूरे भरते हैं।";
    }

    // Vegetables (Sabzi)
    if (lowerMsg.includes('sabzi') || lowerMsg.includes('tamatar') || lowerMsg.includes('mirch') || lowerMsg.includes('vegetable')) {
        return "हमारे पास टमाटर (अभिलाष/हिमसोना), मिर्च, और अन्य सब्जियों के F1 हाइब्रिड बीज उपलब्ध हैं। ये रोग प्रतिरोधी हैं और गमलों या खेत दोनों के लिए उपयुक्त हैं।";
    }

    // Mustard (Sarson)
    if (lowerMsg.includes('sarson') || lowerMsg.includes('mustard') || lowerMsg.includes('rai')) {
        return "सरसों की 'Pusa Bold' और '45S46' किस्में उपलब्ध हैं जिनमें तेल की मात्रा 40-42% होती है। 1 एकड़ के लिए 1 किलो बीज पर्याप्त है।";
    }

    // Delivery & Order
    if (lowerMsg.includes('delivery') || lowerMsg.includes('order') || lowerMsg.includes('kab aayega')) {
        return "ऑर्डर करने के 5 से 7 दिनों के भीतर सामान आपके घर पहुँच जाएगा। हम ट्रैकिंग लिंक भी भेजते हैं। चुनिंदा जगहों पर Cash on Delivery (COD) उपलब्ध है।";
    }

    // Potato (Aloo)
    if (lowerMsg.includes('aloo') || lowerMsg.includes('potato')) {
        return "आलू के बीज (कुफरी किस्में) की बुकिंग सितंबर-अक्टूबर में होती है। स्टॉक अपडेट के लिए वेबसाइट पर 'Notify Me' का उपयोग करें।";
    }


    // --- CATEGORY 3: FERTILIZERS (Khad) ---

    // Urea
    if (lowerMsg.includes('urea') || lowerMsg.includes('nitrogen')) {
        return "नीम कोटेड यूरिया (50kg) ₹1200 में उपलब्ध है। हम सलाह देते हैं कि इसे 2-3 किस्तों में डालें। ज्यादा यूरिया मिट्टी ख़राब करता है, इसलिए नैनो यूरिया का भी प्रयोग कर सकते हैं।";
    }

    // DAP
    if (lowerMsg.includes('dap')) {
        return "DAP का उपयोग बुवाई के समय जड़ों के विकास के लिए करें। बाजार भाव बदलता रहता है (लगभग ₹1350)। स्टॉक के लिए वेबसाइट चेक करें।";
    }

    // Organic / Vermicompost
    if (lowerMsg.includes('jaivik') || lowerMsg.includes('organic') || lowerMsg.includes('vermi') || lowerMsg.includes('kechua')) {
        return "हमारी प्रीमियम 'जैविक खाद' (₹899/25kg) और 'वर्मीकम्पोस्ट' मिट्टी को भुरभुरा बनाते हैं और पैदावार का स्वाद बढ़ाते हैं। रसायनों का प्रयोग कम करने के लिए इनका उपयोग जरूर करें।";
    }

    // NPK
    if (lowerMsg.includes('npk') || lowerMsg.includes('19:19:19')) {
        return "NPK 19:19:19 का स्प्रे फसल की शुरुआती बढ़वार (20-40 दिन) में करें। यह पौधे को हरा-भरा रखता है। 1 एकड़ में 1 किलो NPK को 150 लीटर पानी में मिलाकर स्प्रे करें।";
    }

    // Zinc
    if (lowerMsg.includes('zinc') || lowerMsg.includes('jinko') || lowerMsg.includes('khaira')) {
        return "अगर फसल पीली पड़ रही है या खैरा रोग है, तो जिंक सल्फेट का प्रयोग करें। यह क्लोरोफिल बनाने में मदद करता है।";
    }


    // --- CATEGORY 4: MACHINERY (Yantra) ---

    // Tractor
    if (lowerMsg.includes('tractor')) {
        return "UnnatKheti मिनी ट्रैक्टर की कीमत ₹1,85,000 से शुरू है। यह छोटे किसानों और बागवानी के लिए बेस्ट है। फाइनेंस (EMI) की सुविधा भी उपलब्ध है।";
    }

    // Thresher
    if (lowerMsg.includes('thresher')) {
        return "मल्टी-क्रॉप थ्रेशर मशीन (कीमत ₹45,000) गेहूँ, चना, सोयाबीन आदि के लिए उपयुक्त है। यह दाना नहीं तोड़ती और भूसा साफ़ देती है।";
    }

    // Spray Machine
    if (lowerMsg.includes('spray') || lowerMsg.includes('pump')) {
        return "बैटरी वाला डबल मोटर स्प्रे पंप ₹2500 - ₹4500 में उपलब्ध है। एक चार्ज में 25-30 टंकी स्प्रे होता है।";
    }

    // Drip Irrigation
    if (lowerMsg.includes('drip') || lowerMsg.includes('tapak') || lowerMsg.includes('sinchai')) {
        return "ड्रिप सिंचाई किट (कीमत ₹3500 से शुरू) 60-70% पानी बचाती है और पैदावार बढ़ाती है। सब्जियां और गन्ने के लिए यह तकनीक सर्वोत्तम है।";
    }

    // Rotavator
    if (lowerMsg.includes('rotavator') || lowerMsg.includes('rota')) {
        return "रोटावेटर (5 से 7 फीट) ₹85,000 से ₹1.10 लाख में उपलब्ध है। यह मिट्टी को भुरभुरा बनाता है। इस पर सरकारी सब्सिडी भी मिलती है।";
    }

    // Solar Jhatka / Fencing
    if (lowerMsg.includes('jhatka') || lowerMsg.includes('fencing') || lowerMsg.includes('janwar') || lowerMsg.includes('nilgai')) {
        return "आवारा पशुओं से फसल बचाने के लिए 'सोलर झटका मशीन' (₹8000-₹10000) लगाएं। इससे जानवर को हल्का झटका लगता है और वो खेत से दूर रहता है।";
    }


    // --- CATEGORY 5: FARMING TECHNIQUES & DISEASE (Rog Niyantran) ---

    // Organic Farming Tips
    if (lowerMsg.includes('kaise kare') && (lowerMsg.includes('jaivik') || lowerMsg.includes('organic'))) {
        return "जैविक खेती के लिए रसायनों को धीरे-धीरे कम करें। गोबर की खाद, जीवामृत और हरी खाद का प्रयोग बढ़ाएं। पूर्ण जैविक होने में 3 साल लगते हैं।";
    }

    // Leaf Curl (Patta Modak)
    if (lowerMsg.includes('patta') || lowerMsg.includes('mud') || lowerMsg.includes('leaf curl')) {
        return "पत्ते मुड़ना (Leaf Curl) सफेद मक्खी से फैलता है। 'इमिडाक्लोप्रिड' का छिड़काव करें या हमारा 'नीम आधारित कीटनाशक' (₹450) प्रयोग करें। संक्रमित पौधे उखाड़ दें।";
    }

    // Stem Borer (Tana Chedak)
    if (lowerMsg.includes('tana') || lowerMsg.includes('chedak') || lowerMsg.includes('sundi')) {
        return "तना छेदक के लिए 'Cartap Hydrochloride 4G' (8kg/acre) का प्रयोग करें। खड़ी फसल में क्लोरपायरीफॉस का छिड़काव करें।";
    }

    // Termite (Deemak)
    if (lowerMsg.includes('deemak') || lowerMsg.includes('termite')) {
        return "दीमक से बचने के लिए कच्ची गोबर खाद न डालें। सिंचाई के पानी के साथ 'क्लोरपायरीफॉस' (1 लीटर/एकड़) चलाएं या हींग का प्रयोग करें।";
    }

    // Weed Control (Kharpatwar)
    if (lowerMsg.includes('ghaas') || lowerMsg.includes('kharpatwar') || lowerMsg.includes('weed')) {
        return "खरपतवार नाशक (जैसे Pendimethalin) का प्रयोग बुवाई के 48 घंटे के भीतर करें। खड़ी फसल में चौड़ी/संकरी पत्ती के हिसाब से दवा चुनें।";
    }

    // Seed Treatment
    if (lowerMsg.includes('upchar') || lowerMsg.includes('treatment')) {
        return "बीज उपचार के लिए 1kg बीज में 2-3gm बाविस्टिन या ट्राइकोडर्मा मिलाएं। इससे जड़ गलन और उकठा रोग नहीं लगता।";
    }


    // --- CATEGORY 6: SOIL TEST (Mitti Jaanch) ---

    // Soil Test Process
    if (lowerMsg.includes('mitti') || lowerMsg.includes('soil') || lowerMsg.includes('jaanch') || lowerMsg.includes('test')) {
        return "मिट्टी जाँच के लिए खेत के 5 स्थानों से 6 इंच गहरी मिट्टी मिलाकर आधा किलो सैंपल लें। इसे हमारी लैब या KVK में भेजें। रिपोर्ट 3 दिन में मोबाइल पर मिलेगी। इससे खाद का खर्चा बचता है।";
    }


    // --- CATEGORY 7: GENERAL & SUPPORT ---

    // Contact Number
    if (lowerMsg.includes('number') || lowerMsg.includes('phone') || lowerMsg.includes('call') || lowerMsg.includes('sampark')) {
        return "हमारा हेल्पलाइन नंबर है: [Your Phone Number Here]। आप सोमवार से शनिवार (10 AM - 6 PM) कॉल या व्हाट्सएप कर सकते हैं।";
    }

    // Address
    if (lowerMsg.includes('office') || lowerMsg.includes('address') || lowerMsg.includes('kahan hai')) {
        return "हमारा ऑफिस यहाँ है: 1st Floor Mukta Tower, Near Andheri Station, Mumbai - 400058.";
    }

    // Training
    if (lowerMsg.includes('training') || lowerMsg.includes('sikhna')) {
        return "हम जैविक खेती और मशरूम उत्पादन की ऑनलाइन/ऑफलाइन ट्रेनिंग देते हैं। अपडेट के लिए वेबसाइट का Training सेक्शन देखें।";
    }

    // App Download
    if (lowerMsg.includes('app') || lowerMsg.includes('download')) {
        return "UnnatKheti ऐप डाउनलोड करने के लिए Play Store पर सर्च करें या वेबसाइट के फूटर में दिए लिंक पर क्लिक करें।";
    }

    // Mandi Bhav
    if (lowerMsg.includes('bhav') || lowerMsg.includes('rate') || lowerMsg.includes('mandi')) {
        return "ताज़ा मंडी भाव जानने के लिए agmarknet.gov.in देखें या हमारी वेबसाइट के ब्लॉग सेक्शन में डेली अपडेट चेक करें।";
    }

    // --- NEW CATEGORY: SPECIFIC CROPS (Fasal Jankari) ---

    // Sugarcane (Ganna)
    if (lowerMsg.includes('ganna') || lowerMsg.includes('sugarcane') || lowerMsg.includes('chini')) {
        return "गन्ने की खेती के लिए 'टेंच विधि' अपनाएं। Co-0238 किस्म में रोग आ रहा है, इसलिए नई किस्में जैसे Co-0118 या Co-15023 लगाएं। बुवाई के समय ट्राइकोडर्मा का प्रयोग जरूर करें।";
    }

    // Cotton (Kapas/Narma)
    if (lowerMsg.includes('kapas') || lowerMsg.includes('cotton') || lowerMsg.includes('narma') || lowerMsg.includes('bollworm')) {
        return "नरमा/कपास में गुलाबी सुंडी (Pink Bollworm) से बचने के लिए प्रति एकड़ 4-5 फेरोमोन ट्रैप लगाएं। बीटी कॉटन के प्रमाणित बीज ही खरीदें। अगेती बुवाई (अप्रैल-मई) फायदेमंद रहती है।";
    }

    // Pulses (Dal - Chana/Arhar/Moong)
    if (lowerMsg.includes('chana') || lowerMsg.includes('dal') || lowerMsg.includes('arhar') || lowerMsg.includes('moong') || lowerMsg.includes('urad')) {
        return "दलहनी फसलों के लिए 'राइजोबियम कल्चर' से बीज उपचार जरूर करें। चने की 'GNG-1581' और मूंग की 'Samrat' किस्में बहुत अच्छी हैं। 1 एकड़ में मूंग का 8-10 किलो बीज लगता है।";
    }

    // Soybean
    if (lowerMsg.includes('soyabean') || lowerMsg.includes('soya')) {
        return "सोयाबीन में 'पीला मोजैक' (Yellow Mosaic) की समस्या आती है। इससे बचने के लिए प्रतिरोधी किस्में (जैसे JS-2034, NRC-86) ही बोएं और सफेद मक्खी का नियंत्रण रखें।";
    }

    // Onion & Garlic (Pyaaz/Lahsun)
    if (lowerMsg.includes('pyaaz') || lowerMsg.includes('onion') || lowerMsg.includes('lahsun') || lowerMsg.includes('garlic')) {
        return "प्याज की 'N-53' (खरीफ) और 'एग्रीफाउंड लाइट रेड' (रबी) किस्में अच्छी हैं। लहसुन में कंद का आकार बढ़ाने के लिए पोटाश और सल्फर का प्रयोग जरूर करें।";
    }

    // Fruits (Mango/Banana)
    if (lowerMsg.includes('aam') || lowerMsg.includes('kela') || lowerMsg.includes('mango') || lowerMsg.includes('banana') || lowerMsg.includes('phal')) {
        return "फलों के बागवानी पौधों की बुकिंग के लिए हमारे हेल्पलाइन पर संपर्क करें। आम में बौर आने से पहले फफूंदनाशी का स्प्रे करें और केले में ड्रिप सिंचाई का प्रयोग करें।";
    }


    // --- NEW CATEGORY: ADVANCED MACHINERY (Aadhunik Yantra) ---

    // Power Tiller / Weeder
    if (lowerMsg.includes('tiller') || lowerMsg.includes('weeder') || lowerMsg.includes('chota tractor')) {
        return "सब्जी और बागवानी के लिए 7HP से 12HP के पावर टिलर (कीमत ₹40,000 - ₹65,000) उपलब्ध हैं। यह निराई-गुड़ाई और मिट्टी चढ़ाने का काम आसानी से करते हैं।";
    }

    // Laser Land Leveler
    if (lowerMsg.includes('leveler') || lowerMsg.includes('laser') || lowerMsg.includes('samtal')) {
        return "लेज़र लेवलर से खेत समतल कराने पर पानी की 30% बचत होती है और उपज बढ़ती है। इसे खरीदने पर सरकार भारी सब्सिडी देती है, या आप इसे किराये पर भी ले सकते हैं।";
    }

    // Chaff Cutter (Kutti Machine)
    if (lowerMsg.includes('kutti') || lowerMsg.includes('chaff') || lowerMsg.includes('chara katne')) {
        return "पशुओं के लिए कुट्टी मशीन (Chaff Cutter) ₹15,000 (इलेक्ट्रिक) से शुरू है। यह हरे और सूखे चारे को बारीक काटती है जिससे चारा बर्बाद नहीं होता।";
    }

    // Reaper / Harvester
    if (lowerMsg.includes('reaper') || lowerMsg.includes('katne ki machine') || lowerMsg.includes('harvester')) {
        return "फसल कटाई के लिए रीपर बाइंडर (Reaper Binder) उपलब्ध है जो गेहूं/धान काटकर पूलियां भी बांध देता है। इससे मजदूरी की बड़ी बचत होती है।";
    }


    // --- NEW CATEGORY: SPECIFIC NUTRIENTS & TONICS ---

    // Sulphur (Gandhak)
    if (lowerMsg.includes('sulphur') || lowerMsg.includes('gandhak') || lowerMsg.includes('tel')) {
        return "तिलहनी फसलों (सरसों, सोयाबीन) में सल्फर (Bentonite Sulphur) डालने से तेल की मात्रा बढ़ती है। यह पाले (Frost) से भी बचाता है। 1 एकड़ में 10kg सल्फर डालें।";
    }

    // Potash (MOP)
    if (lowerMsg.includes('potash') || lowerMsg.includes('mop') || lowerMsg.includes('lal khad')) {
        return "पोटाश (MOP) दाने को चमकीला और मोटा बनाता है। आलू और गन्ने में इसका प्रयोग अनिवार्य है। अगर मिट्टी जाँच में कमी है, तो बुवाई के समय 1 बैग पोटाश डालें।";
    }

    // Growth Promoters / Tonics
    if (lowerMsg.includes('tonic') || lowerMsg.includes('booster') || lowerMsg.includes('sagarika') || lowerMsg.includes('humic')) {
        return "फसल की बढ़वार के लिए 'सागरिका' (IFFCO) या 'ह्यूमिक एसिड' का प्रयोग करें। फूल आने से पहले टॉनिक का स्प्रे करने से फल-फूल नहीं झड़ते।";
    }


    // --- NEW CATEGORY: BUSINESS & SUPPORT (Vyapar) ---

    // Franchise / Dealership
    if (lowerMsg.includes('franchise') || lowerMsg.includes('dealership') || lowerMsg.includes('business') || lowerMsg.includes('dukan')) {
        return "UnnatKheti का डीलर बनने के लिए वेबसाइट पर 'Partner With Us' फॉर्म भरें। आपके पास गोदाम/दुकान होनी चाहिए। हम आपको मार्केटिंग और प्रोडक्ट सपोर्ट देंगे।";
    }

    // Returns & Refunds
    if (lowerMsg.includes('wapas') || lowerMsg.includes('return') || lowerMsg.includes('refund') || lowerMsg.includes('kharab nikla')) {
        return "अगर प्रोडक्ट डैमेज मिला है, तो डिलीवरी के 48 घंटे के भीतर हमें फोटो भेजें। हम मुफ्त में रिप्लेसमेंट देंगे या रिफंड प्रोसेस करेंगे।";
    }

    // Payment Issues
    if (lowerMsg.includes('payment') || lowerMsg.includes('paise kat gaye') || lowerMsg.includes('transaction')) {
        return "अगर आपके खाते से पैसे कट गए हैं और ऑर्डर कन्फर्म नहीं हुआ, तो घबराएं नहीं। 24-48 घंटे में पैसा वापस आ जाएगा या हमें ट्रांजेक्शन ID व्हाट्सएप करें।";
    }

    // Login / Password
    if (lowerMsg.includes('login') || lowerMsg.includes('password') || lowerMsg.includes('khul nahi raha')) {
        return "लॉगिन करने के लिए अपना मोबाइल नंबर डालें और OTP का इंतज़ार करें। अगर पासवर्ड भूल गए हैं, तो 'Forgot Password' पर क्लिक करें।";
    }


    // --- NEW CATEGORY: SPECIAL FARMING (Vishesh Kheti) ---

    // Mushroom Farming
    if (lowerMsg.includes('mushroom') || lowerMsg.includes('khumb')) {
        return "मशरूम की खेती कम जगह में लाखों की कमाई दे सकती है। सर्दियों में 'बटन मशरूम' और गर्मी/बरसात में 'ओएस्टर मशरूम' उगाएं। हम इसकी ट्रेनिंग किट भी देते हैं।";
    }

    // Hydroponics (Soilless)
    if (lowerMsg.includes('hydroponic') || lowerMsg.includes('bina mitti') || lowerMsg.includes('paani wali kheti')) {
        return "हाइड्रोपोनिक्स (बिना मिट्टी की खेती) से आप छत पर ही सलाद (Lettuce), स्ट्रॉबेरी आदि उगा सकते हैं। इसका सेटअप थोड़ा महंगा होता है लेकिन पैदावार 4 गुना ज्यादा मिलती है।";
    }

    // Animal Husbandry (Pashu Palan)
    if (lowerMsg.includes('pashu') || lowerMsg.includes('bhains') || lowerMsg.includes('gae') || lowerMsg.includes('cow')) {
        return "पशुपालन के लिए 'पशु किसान क्रेडिट कार्ड' बनवाएं। इसमें बिना गारंटी ₹1.60 लाख तक का लोन मिलता है। अच्छी नस्ल (जैसे मुर्रा भैंस, गिर गाय) ही पालें।";
    }

    // Weather / Frost (Mausam)
    if (lowerMsg.includes('mausam') || lowerMsg.includes('weather') || lowerMsg.includes('paala') || lowerMsg.includes('thand')) {
        return "पाले (Frost) से फसल बचाने के लिए खेत में हल्की सिंचाई करें या शाम को धुआं करें। मौसम की सटीक जानकारी के लिए 'Meghdoot' सरकारी ऐप डाउनलोड करें।";
    }

    // Neelgai / Wild Animals
    if (lowerMsg.includes('neelgai') || lowerMsg.includes('nilgai') || lowerMsg.includes('suar') || lowerMsg.includes('janwar')) {
        return "नीलगाय से बचाव के लिए खेत के चारों ओर बायो-फेंसिंग (करौंदा/बांस) लगाएं। घोल: 4 लीटर मठा + 500 ग्राम तंबाकू का पानी मिलाकर छिड़कने से जानवर दूर रहते हैं।";
    }


    // Default
    if (lowerMsg.includes('hi') || lowerMsg.includes('hello') || lowerMsg.includes('namaste')) {
      return 'नमस्ते! क्या मदद चाहिए? फसल, योजनाएँ, या उत्पादों के बारे में बताएँ।';
    }
    return "क्षमा करें, मैं समझ नहीं पाया। कृपया 'फसल रोग', 'सरकारी योजना', या 'मिट्टी जाँच' जैसे शब्दों का उपयोग करें। अधिक के लिए साइट ब्राउज़ करें।";
  };

  const sendMessage = (e) => {
    e.preventDefault();
    if (!input.trim()) return;

    // Add user message
    setMessages([...messages, { text: input, sender: 'user' }]);
    const botReply = getBotResponse(input);
    
    // Simulate bot delay
    setTimeout(() => {
      setMessages(prev => [...prev, { text: botReply, sender: 'bot' }]);
    }, 500);

    setInput('');
  };

  return (
    <div className={`chatbot-container ${isOpen ? 'open' : ''}`}>
      <button className="chatbot-toggle" onClick={() => setIsOpen(!isOpen)}>
        💬कृषि सहायता
      </button>
      
      {isOpen && (
        <div className="chatbot-window">
          <div className="chatbot-header">
            <h3>Unnat Kheti चैटबॉट</h3>
            <button onClick={() => setIsOpen(false)}>×</button>
          </div>
          
          <div className="chatbot-messages">
            {messages.map((msg, idx) => (
              <div key={idx} className={`message ${msg.sender}`}>
                <p>{msg.text}</p>
              </div>
            ))}
            <div ref={messagesEndRef} />
          </div>
          
          <form className="chatbot-input" onSubmit={sendMessage}>
            <input
              type="text"
              value={input}
              onChange={(e) => setInput(e.target.value)}
              placeholder="आपका सवाल यहाँ टाइप करें..."
              onKeyPress={(e) => e.key === 'Enter' && sendMessage(e)}
            />
            <button type="submit">भेजें</button>
          </form>
        </div>
      )}
    </div>
  );

}
export default Chatbot;